import auth from "./auth";
import welcome from "./welcome";
import notification from "./notification";
import unauthenticated from "./unauthenticated";
import authenticated from "./authenticated";
import layout from "./layout";
import components from "./components";

export const enTranslation = {
  auth,
  welcome,
  notification,
  components,
  ...layout,
  ...unauthenticated,
  ...authenticated,
};
